import React, { lazy, Suspense } from 'react';
import type { CustomField } from '@puckeditor/core';

export type FlexTemplateFieldProps = {
  field: { label?: string };
  name: string;
  readOnly?: boolean;
};

// Only the inspector needs Puck's store; the renderer never mounts this authoring control.
const FlexTemplateWidget = lazy(() => import('./flex-template-widget'));

function FlexTemplateFieldRender(props: FlexTemplateFieldProps): JSX.Element {
  return (
    <Suspense fallback={null}>
      <FlexTemplateWidget {...props} />
    </Suspense>
  );
}

export const flexTemplateField: CustomField<string> = {
  type: 'custom',
  label: 'Template',
  render: FlexTemplateFieldRender,
  // Templates are a UI action, not a stored prop. AI can edit the underlying layout fields.
  ai: { exclude: true },
};
